import { all } from "redux-saga/effects";
import { login } from "../containers/Auth/Login/saga";
import { signup } from "../containers/Auth/SignUp/saga";
import { dashboard } from "../containers/DashBoard/saga";
import { manage } from "../containers/ManageSchedule/saga";
import { chat } from "../containers/Chat/saga";
import { SearchAllocatorSaga } from "../containers/SearchAllocators/saga";
import { myFundsSaga } from "../containers/MyFund/saga";
import { meetings } from "../containers/Profile/MyMeetingsTab/saga";
import { fundDetail } from "../containers/FundDetail/saga";
import { allocatorDetail } from "../containers/AllocatorDetail/saga";
import { profile } from "../containers/Profile/saga";
import { userDetails } from "../containers/UpdateUser/saga";
import { createNewUsers } from "../containers/CreateNewUser/saga";
import { getNewPosts } from "../containers/NewsFeed/saga";
import { createNewPosts } from "../containers/CreateNewPost/saga";
import { getMyPosts } from "../containers/Profile/MyPosts/saga";
import { meetingDetails } from "../containers/MeetingDetail/saga";
import { createFund } from "../containers/CreateFund/saga";
import { createFCNQuery } from "../containers/ContactFCNAdmin/saga";
import { createPerformanceMetrix } from "../containers/PreviousPerformanceMatrix/saga";
import { documentDetail } from "../containers/DocumentDetail/saga";
import { AlertActions } from "../containers/App/ProtectedApp/saga";
import { forgetPasswordSaga } from "../containers/Auth/ForgetPassword/saga";
import { resetPasswordSaga } from "../containers/Auth/RestPassword/saga";
import { Impersonationlogin } from "../containers/Auth/Impersonation/saga";
import { UserPreferencesSaga } from "../containers/UserPreference/saga";
import { CloudDocumentSaga } from "../containers/CloudDocument/saga";
import { stageAllocationSaga } from "../containers/StageAllocation/saga";
import { inMailData } from "../containers/FCNinMails/saga";
export default function* rootSaga() {
  yield all([
    login(),
    signup(),
    manage(),
    chat(),
    dashboard(),
    SearchAllocatorSaga(),
    myFundsSaga(),
    meetings(),
    fundDetail(),
    allocatorDetail(),
    profile(),
    userDetails(),
    createNewUsers(),
    getNewPosts(),
    createNewPosts(),
    getMyPosts(),
    meetingDetails(),
    createFund(),
    createFCNQuery(),
    createPerformanceMetrix(),
    documentDetail(),
    AlertActions(),
    forgetPasswordSaga(),
    resetPasswordSaga(),
    Impersonationlogin(),
    UserPreferencesSaga(),
    CloudDocumentSaga(),
    stageAllocationSaga(),
    inMailData()
  ]);
}
